import styles from './FJExpandableText.module.less';
import { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import FJArrowIcon from '../../../../../assets/svg/community/Prompt-hover.svg?react';

const FJExpandableText = props => {
    const { children, maxLines = 2, lineHeight = 24 } = props;

    // 展开/收起状态
    const [isExpanded, setIsExpanded] = useState(false);
    const [showExpandBtn, setShowExpandBtn] = useState(false);
    const contentRef = useRef(null);

    // 检测文本是否超过指定行数
    useEffect(() => {
        if (contentRef.current && children) {
            setTimeout(() => {
                const maxHeight = lineHeight * maxLines; // 指定行数的高度
                const scrollHeight = contentRef.current.scrollHeight;

                if (scrollHeight > maxHeight) {
                    setShowExpandBtn(true);
                } else {
                    setShowExpandBtn(false);
                }
            }, 200);
        }
    }, [children, maxLines, lineHeight]);

    const handleIconClick = e => {
        e.preventDefault();
        e.stopPropagation();
        setIsExpanded(!isExpanded);
    };

    return (
        <>
            <div className={styles.box}>
                <div
                    ref={contentRef}
                    className={`${styles.content} ${!isExpanded ? styles.content_collapsed : ''}`}
                    style={{
                        WebkitLineClamp: maxLines,
                        maxHeight: !isExpanded ? `${lineHeight * maxLines}px` : 'none',
                    }}
                >
                    {children}
                    {showExpandBtn && isExpanded && (
                        <FJArrowIcon
                            className={`${styles.arrow_icon} ${styles.arrow_icon_left} ${isExpanded ? styles.arrow_icon_expanded : ''}`}
                            onClick={handleIconClick}
                            onMouseDown={e => e.preventDefault()}
                        />
                    )}
                </div>

                {showExpandBtn && !isExpanded && (
                    <div className={styles.ell_box}>
                        <span>...</span>
                        <FJArrowIcon
                            className={`${styles.arrow_icon} ${isExpanded ? styles.arrow_icon_expanded : ''}`}
                            onClick={handleIconClick}
                            onMouseDown={e => e.preventDefault()}
                        />
                    </div>
                )}
            </div>
        </>
    );
};

FJExpandableText.propTypes = {
    children: PropTypes.node.isRequired,
    maxLines: PropTypes.number,
    lineHeight: PropTypes.number,
};

export default FJExpandableText;
